// 导入基础组件
import BaseComponents from '../components';

// 组件插件
export default {
  install(app) {
    // 注册所有基础组件
    app.use(BaseComponents);
  }
}; 